/* avorie-gallery-dots.js — S&S-style gallery: dots + left/right click zones */
(function () {
  function getActiveIndex(slides) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function goToSlide(slides, dots, index) {
    if (index < 0 || index >= slides.length) return;
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    dots.forEach(function (d) { d.classList.remove('is-active'); });
    slides[index].classList.add('is-active');
    dots[index].classList.add('is-active');
  }

  function initGallery() {
    var section = document.querySelector('.section-featured-product');
    if (!section) return;

    var viewer = section.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var slides = viewer.querySelectorAll('.product__media-item');
    if (slides.length <= 1) return;

    /* Don't double-init */
    if (section.querySelector('.avorie-dots')) return;

    /* ── Dot indicators ── */
    var dotContainer = document.createElement('div');
    dotContainer.className = 'avorie-dots';

    var dots = [];
    slides.forEach(function (slide, i) {
      var dot = document.createElement('button');
      dot.className = 'avorie-dots__dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Bild ' + (i + 1));
      if (slide.classList.contains('is-active')) {
        dot.classList.add('is-active');
      }

      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(slides, dots, i);
      });

      dots.push(dot);
      dotContainer.appendChild(dot);
    });

    dotContainer.addEventListener('click', function (e) { e.stopPropagation(); });
    viewer.appendChild(dotContainer);

    /* ── Left/right click-to-navigate zones (appended directly to viewer) ── */
    var prevZone = document.createElement('div');
    prevZone.className = 'avorie-nav-zone avorie-nav-zone--prev';
    prevZone.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var cur = getActiveIndex(slides);
      if (cur > 0) goToSlide(slides, dots, cur - 1);
    });

    var nextZone = document.createElement('div');
    nextZone.className = 'avorie-nav-zone avorie-nav-zone--next';
    nextZone.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var cur = getActiveIndex(slides);
      if (cur < slides.length - 1) goToSlide(slides, dots, cur + 1);
    });

    viewer.appendChild(prevZone);
    viewer.appendChild(nextZone);

    /* ── Sync dots on mobile swipe ── */
    viewer.addEventListener('slideChanged', function (e) {
      var currentEl = e.detail && e.detail.currentElement;
      if (!currentEl) return;
      var mediaId = currentEl.dataset.mediaId;
      slides.forEach(function (slide, i) {
        if (slide.dataset.mediaId === mediaId) {
          goToSlide(slides, dots, i);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();
